import type { TextFieldProps } from "@mui/material";

export enum CharacterLimitMode {
  Truncate = "truncate",
  Warn = "warn",
}

export type TextareaProps = TextFieldProps & {
  maxLength?: number;
  minLength?: number;
  characterLimitMode?: CharacterLimitMode | `${CharacterLimitMode}`;
  characterCounterVisible?: boolean;
  /**
   * Tokens supported in counterText:
   * %value = current character count
   * %minLength   = minimum length
   * %maxLength   = maximum length
   * Example: "%value characters (minimum %minLength characters)"
   */
  counterText?: string;
};
